import React, { useState, useEffect } from "react";
import { useAudio } from "../../../context/AudioContext";

const AudioProgressBar = ({ musicRef, musicData, setIsLoading }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTimeInFormat, setCurrentTimeInFormat] = useState(0);
  const [durationFormat, setDurationFormat] = useState(0);
  const [progress, setProgress] = useState(0);

  const audioContext = useAudio();

  const secondsToMinutesAndSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const formattedMinutes = minutes < 10 ? `${minutes}` : minutes;
    const formattedSeconds =
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  useEffect(() => {
    if (musicData.audio_id === audioContext.audioData.audio_id) {
      const audioElement = musicRef.current;
      const handleTimeUpdate = () => {
        setCurrentTime(audioElement.currentTime);
        setCurrentTimeInFormat(
          secondsToMinutesAndSeconds(audioElement.currentTime)
        );
        setProgress((audioElement.currentTime / duration) * 100);
      };

      const handleLoadedMetadata = () => {
        setDuration(audioElement.duration);
        setDurationFormat(secondsToMinutesAndSeconds(audioElement.duration));
        setProgress((audioElement.currentTime / audioElement.duration) * 100);
      };

      const handleEnded = () => {
        setCurrentTime(0);
        setProgress(0);
        setDuration(0);
        setCurrentTimeInFormat(secondsToMinutesAndSeconds(0));
      };

      handleLoadedMetadata();
      audioElement.addEventListener("timeupdate", handleTimeUpdate);
      audioElement.addEventListener("loadedmetadata", handleLoadedMetadata);
      audioElement.addEventListener("ended", handleEnded);

      return () => {
        audioElement.removeEventListener("timeupdate", handleTimeUpdate);
        audioElement.removeEventListener(
          "loadedmetadata",
          handleLoadedMetadata
        );
        audioElement.removeEventListener("ended", handleEnded);
      };
    }
    console.count('sdfs');
  }, [musicRef.current.currentTime, audioContext.audioData.audio_id, musicData]);

  useEffect(() => {
    if (musicData.audio_id !== audioContext.audioData.audio_id || !audioContext.audioData.audio_id) {
      const audio = new Audio(musicData.url);
      audio.addEventListener("loadedmetadata", () => {
        const durationInSeconds = audio.duration;
        setDurationFormat(secondsToMinutesAndSeconds(durationInSeconds));
        setDuration(durationInSeconds);
        setIsLoading(false);
      });
      setCurrentTimeInFormat(secondsToMinutesAndSeconds(0));
      setCurrentTime(0);
      setProgress(0);
    } else {
      setCurrentTime(musicRef.current.currentTime);
      setDuration(musicRef.current.duration);
      const currTime = musicRef.current.currentTime;
      const dur = musicRef.current.duration;
      setProgress((currTime / dur) * 100);
      setIsLoading(true);
    }
  }, [musicRef, audioContext.audioData.audio_id,musicRef.current.currentTime, setIsLoading, musicData]);

  const handleProgressBarClick = (event) => {
    const progressBar = event.currentTarget;
    const percentageClicked =
      (event.nativeEvent.offsetX / progressBar.offsetWidth) * 100;

    if (!isNaN(percentageClicked) && isFinite(percentageClicked)) {
      const newTime = (percentageClicked / 100) * musicRef.current.duration;

      if (!isNaN(newTime) && isFinite(newTime)) {
        setProgress(percentageClicked);
        musicRef.current.currentTime = newTime;
      }
    }
  };

  return (
    <>
      {/* <div className="relative mt-4">
        <div
          className="bg-slate-100 transition-all duration-500 dark:bg-slate-700 rounded-full overflow-hidden"
          onClick={handleProgressBarClick}
        >
          <div
            className="bg-yellow-300 transition-all duration-500 dark:bg-yellow-300 rounded-full h-2 ring-1 ring-slate-900/5"
            role="progressbar"
            aria-label="music progress"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
      <div className="flex justify-between text-sm leading-6 font-medium tabular-nums">
        <div className="text-cyan-500 transition-all duration-500 dark:text-slate-100">
          {audioContext.audioData.audio_id ? currentTimeInFormat : "0:00"}
        </div>
        <div className="text-slate-500 transition-all duration-500 dark:text-slate-400">
          {durationFormat ? durationFormat : "0:00"}
        </div>
      </div> */}
      <div className="px-6 mb-2">
        <div 
          className="w-full h-2 bg-gray-600 rounded-full cursor-pointer relative"
          onClick={handleProgressBarClick}
        >
          <div 
            className="h-full bg-yellow-400 rounded-full relative transition-all duration-300" 
            style={{ width: `${progress}%` }}
          >
            <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-yellow-400 rounded-full shadow-lg"></div>
          </div>
        </div>
      </div>
      {/* Time */}
      <div className="px-6 flex justify-between text-sm text-gray-200 mb-2">
        <span>{audioContext.audioData.audio_id ? currentTimeInFormat : "0:00"}</span>
        <span>{durationFormat ? durationFormat : "0:00"}</span>
      </div>
    </>
  );
};

export default AudioProgressBar;
